export const plans = [
  {
    id: 1,
    name: 'Starter Plan',
    price: 59.99,
    meals: 6,
    popular: false,
    features: [
      '6 meals per week',
      'Free delivery',
      'Flexible menu selection',
      'Cancel anytime',
      'Nutritionist approved',
    ],
  },
  {
    id: 2,
    name: 'Fit Plan',
    price: 109.99,
    meals: 12,
    popular: true,
    features: [
      '12 meals per week',
      'Free delivery',
      'Priority menu access',
      'Cancel anytime',
      'Nutritionist approved',
      'Personalized recommendations',
      '10% discount on extras',
    ],
  },
  {
    id: 3,
    name: 'Family Plan',
    price: 169.99,
    meals: 20,
    popular: false,
    features: [
      '20 meals per week',
      'Free delivery',
      'Priority menu access',
      'Cancel anytime',
      'Nutritionist approved',
      'Personalized recommendations',
      '15% discount on extras',
      'Dedicated support',
    ],
  },
];